import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Unstable_Grid2';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';

import '../../style/SignupForm.css';

const FormSelectField = ({ id, name, label, required, defaultValue, menuItems, onChange, onBlur, hasTranslations, errors }) => {
  const { t } = useTranslation();

  return (
    <Grid xs={12} sm={12} md={6} lg={6} className="form-input">
      <FormControl fullWidth size="small" variant="outlined" error={Boolean(errors)}>
        <InputLabel id={`${name}-select`}>{t(label)} {required ? '*' : ''}</InputLabel>
        <Select
          id={id}
          required={required}
          size="small"
          name={name}
          labelId={`${name}-select`}
          label={t(label)}
          onChange={onChange}
          onBlur={onBlur}
          defaultValue={defaultValue || ''}
        >
          {menuItems.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {hasTranslations ? t(item.value) : item.label}
            </MenuItem>
          ))}
        </Select>
        {errors && (
          <FormHelperText className="outlined-required-helper-text">
            {errors}
          </FormHelperText>
        )}
      </FormControl>
    </Grid>
  );
};

export default FormSelectField;